import { Cog } from "lucide-react";
import { initials } from "@/lib/initials";
import { cn } from "@/lib/utils";

const SIZE = { sm: "size-7 text-xs", md: "size-9 text-sm" } as const;

/** Baş harf rozeti (ui.md §12.7). Dekoratif: adın kendisi her zaman yanında metin olarak yazar. `name` yoksa sistem olayı. */
export function UserAvatar({ name, size = "sm", className }: { name?: string | null; size?: keyof typeof SIZE; className?: string }) {
  return (
    <span aria-hidden="true" data-slot="user-avatar" className={cn("inline-flex shrink-0 items-center justify-center rounded-full font-medium", name ? "bg-avatar text-avatar-foreground" : "bg-muted text-muted-foreground", SIZE[size], className)}>
      {name ? initials(name) : <Cog className="size-4" />}
    </span>
  );
}
